import { render, staticRenderFns } from "./IssueTrackerTableExpansion.vue?vue&type=template&id=5c494731&scoped=true&"
import script from "./IssueTrackerTableExpansion.vue?vue&type=script&lang=js&"
export * from "./IssueTrackerTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./IssueTrackerTableExpansion.vue?vue&type=style&index=0&id=5c494731&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c494731",
  null
  
)

export default component.exports